import { UserEntityConfig }      from '@app/modules/user/presets/user-entity-config.model';
import {
	ManagedObject,
	ManagedObjectTypeEnum
}                                from '@app/shared/models/managed-object.model';
import { RoleTypes }             from '@app/shared/models/roles.model';
import { RequestState }          from '@core/interfaces/api.interface';
import { IUserEntityEvents }     from '@core/interfaces/entity.interface';
import { EntityActionEventEnum } from '@models/entity.model';


// ENUMS #############################################################
// API enums *********************************************************
export enum UserStatusEnum {
	ACTIVE = 'active',
	DISABLED = 'disabled',
}

export enum RealmEnum {
	DF = 'df'
}

// UI enums *********************************************************
export enum UserFormsEnum {
	CHANGE_PASSWORD = 'changePassword',
	USER = 'user'
}

export enum UserPresetEnum {
	ADMIN_USER = 'adminUser',
	ADMIN_USER_CROSS_REALM = 'adminUserCrossRealm',
	CURRENT_USER = 'currentUser',
	USER = 'user'
}


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IUserEntityActionEvent {
	action: EntityActionEventEnum;
	user: User;
	userEntityConfig: UserEntityConfig;
}

// TYPES #############################################################
export type UserProps = ( keyof User )[];

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class UserTMO {
	public id: string = undefined;

	public email: string = undefined;

	public firstname: string = undefined;

	public lastname: string = undefined;

	public createdDate: Date = undefined;

	public phoneNumber: string = undefined;

	public status: UserStatusEnum = undefined;

	public emailVerified: boolean = undefined;

	public tenantId: string = undefined;

	public managedObject: ManagedObject = new ManagedObject();

	public picture: string = undefined;

	public realm: RealmEnum = undefined;

	public settings: Settings = new Settings();

	public username: string = undefined;

	/**
	 * Locale. Supported values are `de` and `en`.
	 */
	public locale?: string = undefined;
}

export class UserUpdateBodyTMO {
	public firstname: string = undefined;

	public lastname: string = undefined;

	public phoneNumber: string = undefined;

	public roles: RoleTypes[] = [];

	public managedObject: ManagedObject = new ManagedObject();

	public picture: string = undefined;

	public settings: Settings = new Settings();

	public locale?: string = undefined;
}

export class UserCreateBodyTMO extends UserUpdateBodyTMO {

	public tenantId: string = undefined;

	public email: string = undefined;
}

export class UserStatusBodyTMO {
	public status: UserStatusEnum = undefined;
}

export class UserChangePassTMO {
	public password: string = undefined;
}

export class SettingsTMO {
	public email: EmailSettingsTMO = new EmailSettings();
}

export class EmailSettingsTMO {
	public fcc?: boolean = undefined;
	public archiving?: boolean = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class User extends UserTMO {

	public roles: RoleTypes[] = [];

	public managedObjectId?: string = undefined;

	public managedObjectType?: ManagedObjectTypeEnum = undefined;

	public etag?: string = undefined;

	public ui?: IUserEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {}
	};
}

export class UserChangePass extends UserChangePassTMO {
	public id?: string = undefined;
	public etag?: string = undefined;
	public confirmPassword: string = undefined;
}

export class Settings extends SettingsTMO {}

export class EmailSettings extends EmailSettingsTMO {}
